<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Установить настройки звука</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="dialogSound" persistent max-width="500">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Установить настройки звука</v-card-title>
          <v-form
            ref="formSoundDoorphone"
            v-model="validSound"
            lazy-validation
          >
            <v-row class="ma-3">
              <v-col
                cols="12"
                class="py-0"
              >
                <v-text-field
                  v-model='formSound.soundVolume'
                  flat
                  label="Чувствительность микрофона"
                  outlined
                  :rules="[
                    value => value >= 0 || 'Введите целое число',
                    value => value <= 15 || 'Значение не должно превышать 15',
                  ]"
                  type="number"
                  dense
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                class="py-0"
              >
                <v-text-field
                  v-model='formSound.speakerVolume'
                  flat
                  label="Громкость динамика"
                  :rules="[
                    value => value >= 0 || 'Введите целое число',
                    value => value <= 15 || 'Значение не должно превышать 15',
                  ]"
                  type="number"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                class="py-0"
              >
                <v-text-field
                  v-model='formSound.echoStopperVolume'
                  flat
                  label="Уровень эхоподавления"
                  :rules="[
                    value => value >= 0 || 'Введите целое число',
                  ]"
                  type="number"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                class="py-0 pl-4"
              >
                <v-switch
                  v-model="formSound.closingDoor"
                  flat
                  inset
                  label="Предупреждение о закрытии двери"
                >
                </v-switch>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="dialogSound = false"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              class="text-none"
              @click="validateSoundSettings"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="issetRightDoorphones()">
              <h3>Успешно изменён на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.right_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
            <v-col v-if="issetFailDoorphones()">
              <h3>Не удалось изменить на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.fail_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResult = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SoundSettings',
  props: ['doorphones'],
  data () {
    return {
      validSound: true,
      dialogSound: false,
      formSound: {
        echoStopperVolume: '',
        soundVolume: '',
        closingDoor: false,
        speakerVolume: '',
      },
      dialogResult: false,
      updateResult: {},
    };
  },
  methods: {
    ...mapActions({
      massUpdateSoundSettings: 'Doorphone/massUpdateSoundSettings',
    }),
    issetRightDoorphones () {
      return this.updateResult.right_doorphones && this.updateResult.right_doorphones.length > 0;
    },
    issetFailDoorphones () {
      return this.updateResult.fail_doorphones && this.updateResult.fail_doorphones.length > 0;
    },
    validateSoundSettings () {
      if (this.$refs.formSoundDoorphone.validate()) {
        const dataSound = {
          cHandoffSendVolume: this.formSound.soundVolume,
          cSpeakerVolume: this.formSound.speakerVolume,
          cAECLevel: this.formSound.echoStopperVolume,
        };
        this.formSound.closingDoor ? dataSound.cOpenDoorWarning = '1' : dataSound.cOpenDoorWarning = '0';
        const selectedDoorphoneId = this.doorphones.map(doorphone => { return doorphone.id; });
        this.massUpdateSoundSettings({
          doorphones: selectedDoorphoneId,
          settings: dataSound,
        })
          .then((res) => {
            this.dialogSound = false;
            this.updateResult = res;
            this.dialogResult = true;
          })
          .catch(e => console.error(e));
      } else {
        this.$flash_warning('Заполните все поля');
      }
    },
  },
};
</script>

<style scoped>

</style>
